<template>
  <div class="channel_content">
    <img src="~@/assets/images/coo/image_pc.png" class="l">
    <div class="r">
      <ul>
        <li>
          <div class="title">预裁定</div>
          <div class="desc">提供预裁定咨询服务并协助企业向海关递交申请与获得裁定。预归类、预审价、原产地预确定</div>
        </li>
        <li>
          <div class="title">贸易合规</div>
          <div class="desc">为企业在特定国家或地区的进出口活动提供法律法规咨询、AEO咨询、FTA咨询、贸易管制咨询、知识产权边境保护</div>
        </li>
        <li>
          <div class="title">海关稽查</div>
          <div class="desc">协助应对海关稽查，准备说明资料，最小化稽查风险。原产地稽查、归类稽查、价格稽查、加工贸易稽查</div>
        </li>
      </ul>
      <div class="btns">
        <router-link class="btn" :to="{name: 'RulesDecide'}">原产地预判定</router-link>
        <router-link class="btn cert" :to="{name: 'RulesDecideCertList'}">原产地证书</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RulesDecideGuideContentZH'
}
</script>
<style scoped>
.channel_content{
  position: absolute;
  top: 50%;
  /* left: 12.5%;
  transform: translateY(-50%); */
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  /* justify-items: center; */
  justify-content: space-around;
  align-items: center;
}
.channel_content .l{
  width: 360px;
  /* position: absolute;
  top: 50%;
  left: 12.5%;
  transform: translateY(-50%); */
  margin-right: 130px;
}
.channel_content .r{
  width: 480px;
  flex-shrink: 0;
  /* position: absolute;
  top: 50%;
  right: 10%;
  transform: translateY(-50%); */
}
.channel_content .r ul li{
  margin-bottom: 25px;
}
.channel_content .r ul li .title{
  background: url("~@/assets/images/coo/icon.png") 0 center no-repeat transparent;
  background-size: 13px auto;
  padding-left: 22px;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
}
.channel_content .r ul li .desc{
    color: #999;
    font-size: 14px;
    line-height: 22px;
}
.btns{
  margin-top: 10px;
  display: flex;
}
.btn{
  background-image: linear-gradient(90deg, #42BEFF 9%, #1F8AFD 100%);
  border-radius: 3px;
  text-align: center;
  width: 125px;
  height: 38px;
  line-height: 38px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: block;
}
.btn::after{
  display: none;
}
.btn.cert{
  margin-left: 18px;
  background: none;
  color: #1F8AFD;
  border: 1px solid #1F8AFD;
}
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/GuideContent.vue